// extracted by mini-css-extract-plugin
module.exports = {"title":"choose-list-component_title__3JeX3","chooseList":"choose-list-component_chooseList__yuycb","radioList":"choose-list-component_radioList__1BI47"};